// extracted by mini-css-extract-plugin
export default {"h1":"VendorCalc_h1__-Q2Vx","borderTop":"VendorCalc_borderTop__eLii8","depthMove":"VendorCalc_depthMove__ES1K-"};